import script from "./index-component.vue?vue&type=script&setup=true&lang=js"
export * from "./index-component.vue?vue&type=script&setup=true&lang=js"

import "./index-component.vue?vue&type=style&index=0&id=675cf350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675cf350"]])

export default __exports__